module.exports = __webpack_public_path__ + "static/media/asc-off-app-provider-icon.92cd6a9c.svg";